export default "__VITE_ASSET__a57f4091__"